import React from "react";

import { Box, Typography, Container, Grid, Card, CardContent, Button } from "@mui/material";
 
const Careers = () => {

  return (
<Container maxWidth="lg" sx={{ py: 6 }}>
<Typography variant="h3" component="h1" align="center" gutterBottom>

        Careers at Del Toro Insurance
</Typography>
<Typography variant="h6" component="h2" align="center" color="textSecondary" paragraph sx={{ mb: 5 }}>

        Join our team and make a difference in people's lives
</Typography>
<Box sx={{ my: 4 }}>
<Typography variant="h4" component="h2" gutterBottom>

          Why Work With Us
</Typography>
<Typography paragraph>

          At Del Toro Insurance, we believe our team is our greatest asset. We foster a collaborative environment where innovation is encouraged, hard work is rewarded, and career growth is prioritized. Our employees enjoy competitive benefits, ongoing professional development opportunities, and the satisfaction of helping our clients protect what matters most to them.
</Typography>
</Box>
 
      <Typography variant="h4" component="h2" gutterBottom sx={{ mt: 5, mb: 3 }}>

        Current Openings
</Typography>
<Grid container spacing={4}>

        {[

          { title: "Insurance Sales Representative", location: "Miami, FL", type: "Full-time", description: "Looking for an experienced sales professional to join our growing team. Responsibilities include developing new business, servicing existing accounts, and providing exceptional customer service." },

          { title: "Claims Specialist", location: "Fort Lauderdale, FL", type: "Full-time", description: "Seeking a detail-oriented claims specialist to process insurance claims efficiently and accurately while providing compassionate support to our policyholders during the claims process." },

          { title: "Customer Service Representative", location: "Remote", type: "Part-time", description: "Join our customer service team to assist clients with policy questions, changes, and general inquiries. Strong communication skills and insurance knowledge required." }

        ].map((job, index) => (
<Grid item xs={12} md={6} key={index}>
<Card sx={{ height: '100%' }}>
<CardContent>
<Typography variant="h5" component="h3" gutterBottom>

                  {job.title}
</Typography>
<Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
<Typography color="textSecondary">

                    {job.location}
</Typography>
<Typography color="textSecondary">

                    {job.type}
</Typography>
</Box>
<Typography paragraph>

                  {job.description}
</Typography>
<Button variant="contained" sx={{ bgcolor: '#ffcc00', color: 'black', '&:hover': { bgcolor: '#e6b800' } }}>

                  Apply Now
</Button>
</CardContent>
</Card>
</Grid>

        ))}
</Grid>
<Box sx={{ mt: 6, textAlign: 'center' }}>
<Typography variant="h5" component="h3" gutterBottom>

          Don't see a position that fits your skills?
</Typography>
<Typography paragraph>

          We're always interested in connecting with talented professionals. Send your resume to careers@deltoro-insurance.com
</Typography>
</Box>
</Container>

  );

};
 
export default Careers;
 